import { applicationCountries } from '@/shared/tools/applicationCountries'
import PropTypes from 'prop-types'

const ApplicationCountry = ({ country }) => {
  const flag = applicationCountries[country] || ''
  if (!flag) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '10px',
        marginBottom: '2rem',
      }}
    >
      {flag}
    </div>
  )
}

ApplicationCountry.propTypes = {
  country: PropTypes.string.isRequired,
}

export default ApplicationCountry
